// extracted by mini-css-extract-plugin
export var cardHeader = "_u9-0";
export var reorderHandle = "_u9-3";
export var titleArea = "_u9-1";
export var titleAreaWithHandle = "_u9-2";